import { API } from "./apiAuth";

const uploadVideoApi = async (formData) => {
    try {
      const response = await API.post("admin/rising_upload", formData ,{headers: {
        "Content-Type": "multipart/form-data"}});
      return response.data;
    } catch (error) {
      return {"error" : "등록에 실패하였습니다. 다시 시도해주세요."}
    }
};

const updateVideoApi = async (formData,info) => {
  try {
    const response = await API.put(`admin/rising_update?date=${info.date}&lang=${info.lang}`, formData ,{headers: {
      "Content-Type": "multipart/form-data"}});
    return response.data;
  } catch (error) {
    return {"error" : "등록에 실패하였습니다. 다시 시도해주세요."}
  }
};

const deleteVideoApi = async (info) => {
  try {
    const response = await API.delete(`admin/rising_delete?date=${info.date}&lang=${info.lang}`);
    return response.data;
  } catch (error) {
    return error;
  }
};

const getBriefingListApi = async (info) => {
    try {
      const response = await API.get(`admin/select_video_rising?page=${info.page}&size=${info.size}&language=${info.language}`);
      return response.data;
    } catch (error) {
      return;
    }
};

export default{
    uploadVideoApi,
    updateVideoApi,
    deleteVideoApi,
    getBriefingListApi
}